import CardVal from 'card-validator';

import { mapCardBrandToIugu } from './mapCardBrandToIugu';

export function getCardValues(data) {
  const { holder_name, display_number, expiration_date, cvv } = data;

  const number = display_number.split(' ').join('');

  const { card } = CardVal.number(number);
  const brand = mapCardBrandToIugu(card?.type);

  const holderNameSplited = holder_name.split(' ');

  let first_name = holder_name;
  let last_name = '';

  if (holderNameSplited.length > 1) {
    first_name = holder_name.split(' ')[0];
    last_name = holder_name.trim().split(' ')[1];
  }

  const expirationDateSplited = expiration_date.split('/');

  let month;
  let year;

  if (expirationDateSplited.length > 1) {
    month = expirationDateSplited[0];
    year = `20${expirationDateSplited[1]}`;
  }

  const verification_value = cvv;

  return {
    number,
    first_name,
    last_name,
    month,
    year,
    verification_value,
    brand,
  };
}
